"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProblemCode = void 0;
/**
 * Error codes sent by the backend API server.
 */
var ProblemCode;
(function (ProblemCode) {
    /**
     * This is the general fallback. Don't throw this directly, either choose
     * a more specific ProblemCode or just throw a normal Error (or let the
     * original error propagate). The express middleware will catch it, and throw
     * this ProblemCode for you.
     */
    ProblemCode["InternalServerError"] = "InternalServerError";
    /**
     * This account does not have access to the required feature.
     * e.g. the account doesn't have the right paid plan to use the feature.
     */
    ProblemCode["AccountFeatureAccessDenied"] = "AccountFeatureAccessDenied";
    /**
     * The user does not have permission (the necessary role) to do the requested
     * action on the account.
     */
    ProblemCode["UserAccountPermissionDenied"] = "UserAccountPermissionDenied";
    /**
     * Authentication of the request failed.
     * e.g. the user is not authenticated (has not logged in), or their access
     * token has expired and needs to be refreshed.
     */
    ProblemCode["Unauthorised"] = "Unauthorised";
    /**
     * The user is known (authenticated), but they don't have permission to do
     * the requested action.
     * e.g. the user is trying to edit a transaction which doesn't belong to the
     * current account.
     */
    ProblemCode["Forbidden"] = "Forbidden";
    ProblemCode["BadRequest"] = "BadRequest";
    /**
     * Could not find a resource which was required for the API call. Use this
     * for DB lookups where a resource was expected but wasn't returned.
     *
     * These can occur due e.g. due concurrent updates to a resource causing it
     * to no longer be available.
     */
    ProblemCode["ResourceNotFound"] = "ResourceNotFound";
    /**
     * The request failed as the resulting event/ transaction would not be valid.
     */
    ProblemCode["TransactionInvalid"] = "TransactionInvalid";
    /**
     * For validation errors in the **request** itself.
     * e.g. a provided value is out of range.
     */
    ProblemCode["ValidationFailed"] = "ValidationFailed";
    ProblemCode["FieldRequired"] = "FieldRequired";
    ProblemCode["FileRequired"] = "FileRequired";
    /**
     * The user is attempting to import a file type which isn't
     * supported in Syla.
     */
    ProblemCode["UnsupportedFileType"] = "UnsupportedFileType";
    ProblemCode["RefreshedExpiredOtp"] = "RefreshedExpiredOtp";
    /**
     * User attempted an email signup, but they took too long and it expired.
     */
    ProblemCode["EmailRegistrationExpired"] = "EmailRegistrationExpired";
    ProblemCode["VerifiedUserAlreadyExists"] = "VerifiedUserAlreadyExists";
    ProblemCode["GoogleAuthFailed"] = "GoogleAuthFailed";
    ProblemCode["EmailDisallowed"] = "EmailDisallowed";
    /**
     * Login/ auth failed as the email provided does not exist.
     */
    ProblemCode["UserEmailNotFound"] = "UserEmailNotFound";
    /**
     * Login/ auth failed as the password was incorrect.
     */
    ProblemCode["IncorrectPassword"] = "IncorrectPassword";
    /**
     * User has no password set, making auth via email and password impossible.
     */
    ProblemCode["UserHasNoPassword"] = "UserHasNoPassword";
    ProblemCode["SamePassword"] = "SamePassword";
    ProblemCode["ExpiredLink"] = "ExpiredLink";
    ProblemCode["InviteExpired"] = "InviteExpired";
    ProblemCode["InviteInvalid"] = "InviteInvalid";
    ProblemCode["InvitePasswordRequired"] = "InvitePasswordRequired";
    ProblemCode["CannotDeleteLastAccount"] = "CannotDeleteLastAccount";
    ProblemCode["AlreadyInProgress"] = "AlreadyInProgress";
    ProblemCode["UserAlreadyHasAccess"] = "UserAlreadyHasAccess";
    ProblemCode["UserInviteNotFound"] = "UserInviteNotFound";
    ProblemCode["AccountMustHaveOwner"] = "AccountMustHaveOwner";
    ProblemCode["SubscriptionAlreadyExists"] = "SubscriptionAlreadyExists";
    /**
     * Exceeded the maximum number of rows allowed in a single import attempt.
     */
    ProblemCode["ExceededRecordLimit"] = "ExceededRecordLimit";
    /**
     * The file format was recognised, but it couldn't be imported due to
     * validation or parsing errors.
     */
    ProblemCode["FailedFileImport"] = "FailedFileImport";
    /**
     * The user has attempted to fill out one of the custom file templates, but
     * it doesn't match the expected format.
     */
    ProblemCode["InvalidCustomFileTemplate"] = "InvalidCustomFileTemplate";
    /**
     * The provided API Key, or Address failed validation.
     */
    ProblemCode["ValidateKeysFailed"] = "ValidateKeysFailed";
    /**
     * The resource is currently locked and can't be accessed.
     *
     * This is used to prevent concurrent access to certain resources.
     */
    ProblemCode["ResourceLocked"] = "ResourceLocked";
})(ProblemCode = exports.ProblemCode || (exports.ProblemCode = {}));
